module.exports = __webpack_public_path__ + "static/media/star_green-min.b4e0780b.png";